import { useBeforeUnload, useBlockNavigation } from '../../../hooks'

// A settings tab lives in the query, so switching tabs would drop the edits silently
function SettingsNavigationGuard({ dirty }) {
  useBlockNavigation(dirty, { isSearchChangeBlocked: true })
  useBeforeUnload(dirty, true)

  return null
}

export default SettingsNavigationGuard
